import React from "react";

import { PlantingTipAppearsInAppNote } from "./plantingTipFooter";

export const PLANTING_FERTILIZER_CALIBRATION_HELP_TITLE =
  "Dica de regulagem de adubo";

export function PlantingFertilizerCalibrationHelpContent() {
  return (
    <>
      <p>
        Use no <strong>início do plantio</strong>, em{" "}
        <strong>troca de adubo</strong> ou em{" "}
        <strong>conferências de rotina</strong> para verificar a dosagem de
        adubo da plantadeira. Há duas conferências: a rápida (pré-regulagem) e
        a completa (desgaste mecânico).
      </p>
      <p>
        <strong>1. Pré-regulagem — dosagem rápida (início de safra ou troca de adubo)</strong>
      </p>
      <p>
        Serve para saber, de forma rápida, quanto de adubo está caindo por
        hectare.
      </p>
      <ol>
        <li>
          Colete adubo em pelo menos <strong>10% das linhas</strong>. Exemplo:
          plantadeira de 30 linhas → colete em <strong>3 linhas</strong>.
        </li>
        <li>
          De preferência, colete <strong>uma linha em cada seção</strong> da
          plantadeira. Se ela tiver mais de uma seção, colete pelo menos uma
          linha em cada seção.
        </li>
        <li>
          Em plantadeiras <strong>a vácuo</strong>, a coleta não pode impedir a
          saída de ar no final do tubo. Saco plástico ou qualquer coisa que
          feche a saída de ar compromete o sistema e o adubo deixa de cair
          direito.
        </li>
        <li>
          Percorra <strong>50 a 100 metros</strong> e anote a distância exata.
        </li>
        <li>
          Pese o adubo que caiu em cada linha testada e informe na
          calculadora no início do check de calibragem. Com o espaçamento
          entre linhas, o app calcula a dosagem em <strong>kg/ha</strong>.
        </li>
      </ol>
      <p>
        <strong>2. Conferência por desgaste — todas as linhas iguais</strong>
      </p>
      <p>
        Quando a plantadeira já tem <strong>desgaste mecânico</strong>, o
        correto é coletar o adubo em <strong>todas as linhas</strong>, para
        conferir se todas estão caindo a mesma dosagem.
      </p>
      <p>
        <strong>Depois da pré-regulagem: check a cada abastecimento</strong>
      </p>
      <p>
        A pré-regulagem vale para o início do plantio. No dia a dia, faça o
        check de calibragem <strong>a cada abastecida</strong>, no adubo e na
        semente: informe os hectares do painel da plantadeira e a quantidade de
        adubo e de semente colocada. A plataforma acompanha a dosagem. Se sair
        da margem de <strong>5%</strong>, aparece alerta visual na plataforma e
        no app.
      </p>
      <PlantingTipAppearsInAppNote />
    </>
  );
}
